import moment from 'moment-timezone';
import { VISIT_TYPE_LABELS } from 'modules/Media/mediaUtils';

/**
 * A note's date as a moment in the account's time zone — the zone the rest of the app shows times in
 * (the visit page's "Submitted time", the media tiles). The API sends UTC; formatting it in the
 * browser's zone showed the same moment as 10:17 on a visit and 17:17 on its note. Falls back to the
 * browser's zone only while the account's isn't known yet.
 */
export const noteMoment = (date, timeZone) => {
  if (!date) return null;
  const when = moment(date);
  return timeZone ? when.tz(timeZone) : when;
};

/** The visit-type badge text a visit note carries, e.g. "Education visit". Null for manual notes. */
export const visitBadgeLabel = (note) => {
  const label = VISIT_TYPE_LABELS[note?.visit_type];
  return label ? `${label} visit` : null;
};

/**
 * The reason worth printing under the header. Visit notes taken from the visit's Notes field come back
 * with the reason auto-filled as "<Type> visit" — the exact text of the badge beside it — so that one
 * is dropped. A form question title ("Field notes") or a manual reason is kept.
 */
export const displayReason = (note) => {
  const reason = note?.reason?.trim();
  if (!reason) return null;
  return reason === visitBadgeLabel(note) ? null : reason;
};
